module.exports = __webpack_public_path__ + "media/assets/icons/whatsapp-80b56dc8f1ab6555950e2043afe3a478.svg";